import { render } from "./tileserver-config.vue?vue&type=template&id=7ce7dda6"
import script from "./tileserver-config.vue?vue&type=script&lang=ts"
export * from "./tileserver-config.vue?vue&type=script&lang=ts"
script.render = render

export default script